import React from 'react';

function ShareToWorkspaceModal({ 
  showShareModal, 
  setShowShareModal, 
  patentToShare, 
  setPatentToShare,
  userWorkspaces,
  selectedWorkspaceId,
  setSelectedWorkspaceId,
  shareNote,
  setShareNote,
  shareToWorkspace,
  setPage
}) {
  
  if (!showShareModal || !patentToShare) {
    return null;
  }

  const handleCancel = () => {
    setShowShareModal(false);
    setPatentToShare(null);
  };

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
      <div style={{ background: 'white', borderRadius: '8px', padding: '24px', maxWidth: '500px', width: '90%' }}>
        <h2 style={{ fontSize: '20px', fontWeight: '600', color: '#1d2934', marginBottom: '16px' }}>Share to Workspace</h2>
        <p style={{ color: '#5e778a', fontSize: '14px', marginBottom: '16px' }}>
          Sharing: <strong>{patentToShare.id}</strong>
        </p>

        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', fontSize: '14px', color: '#5e778a', marginBottom: '8px' }}>Select Workspace</label>
          {userWorkspaces.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '20px', background: '#f8f9fa', borderRadius: '8px' }}>
              <p style={{ color: '#5e778a', fontSize: '14px', marginBottom: '12px' }}>You don't have any workspaces yet.</p>
              <p style={{ color: '#5e778a', fontSize: '13px', marginBottom: '16px' }}>Create a workspace to share patents with your team.</p>
              <button
                onClick={() => { setShowShareModal(false); setPatentToShare(null); if (setPage) setPage('workspaces'); }}
                style={{ padding: '10px 20px', background: '#53dafc', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: '600' }}
              >
                Create Workspace
              </button>
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {userWorkspaces.map((ws) => (
                <div
                  key={ws.id}
                  onClick={() => setSelectedWorkspaceId(ws.id)}
                  style={{
                    textAlign: 'left',
                    padding: '12px',
                    background: selectedWorkspaceId === ws.id ? '#e0f2fe' : '#f8f9fa',
                    border: selectedWorkspaceId === ws.id ? '2px solid #53dafc' : '1px solid #e0e0e0',
                    borderRadius: '4px',
                    cursor: 'pointer'
                  }}
                >
                  <div style={{ fontWeight: '500', color: '#1d2934' }}>{ws.name}</div>
                  <div style={{ fontSize: '12px', color: '#5e778a' }}>{ws.members_count} members</div>
                </div>
              ))}
            </div>
          )}
        </div>

        <div style={{ marginBottom: '24px' }}>
          <label style={{ display: 'block', fontSize: '14px', color: '#5e778a', marginBottom: '8px' }}>Note (optional)</label>
          <input
            type="text"
            value={shareNote}
            onChange={(e) => setShareNote(e.target.value)}
            placeholder="Why are you sharing this patent?"
            style={{ width: '100%', padding: '10px', border: '1px solid #e0e0e0', borderRadius: '4px', fontSize: '14px' }}
          />
        </div>

        <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
          <button
            onClick={handleCancel}
            style={{ padding: '10px 20px', border: '1px solid #e0e0e0', borderRadius: '4px', background: 'white', cursor: 'pointer' }}
          >
            Cancel
          </button>
          <button
            onClick={() => shareToWorkspace(selectedWorkspaceId)}
            disabled={!selectedWorkspaceId}
            style={{
              padding: '10px 20px',
              border: 'none',
              borderRadius: '4px',
              background: selectedWorkspaceId ? '#059669' : '#ccc',
              color: 'white',
              cursor: selectedWorkspaceId ? 'pointer' : 'not-allowed'
            }}
          >
            Share Patent
          </button>
        </div>
      </div>
    </div>
  );
}

export default ShareToWorkspaceModal;
